import {
  cacheTag,
  executeQuery,
  executeQueryWithAutoPagination
} from './execute-query'
import { graphql, readFragment } from './graphql'

export {
  cacheTag,
  executeQuery,
  executeQueryWithAutoPagination,
  graphql,
  readFragment
}
